<kendo-grid #grid
  [data]="svc.viewData | async"
  [kendoGridReactiveEditing]="svc.createFormGroup"
  [sortable]="{mode: 'multiple'}"
  [filterable]="true"
  [pageable]="true"
  [pageSize]="svc.gridState.take"
  [scrollable]="'scrollable'"
  [navigable]="true"
  [reorderable]="true"
  [resizable]="true"
  [skip]="svc.gridState.skip"
  [sort]="svc.gridState.sort"
  [kendoGridSelectBy]="config().kendoGridSelectBy"
  [selectedKeys]="svc.selectedKeys"
  (cellClick)="svc.editClick($event, true, true)"
  (cellClose)="svc.cellClose($event)"
  (dataStateChange)="svc.dataStateChange($event)"
  (selectionChange)="svc.selectionChange($event)"
  [filter]="svc.gridState.filter"
  (add)="svc.addHandler($event)"
  style="height: 100%;">

  <ng-template kendoGridToolbarTemplate>
    @if (svc.loading) {
      <kendo-loader type="converging-spinner" size="small"></kendo-loader>
    }
    <div class="grid-action-buttons">
      @if (canCreateNewRow) {
        <button type="button" themeColor="primary" kendoGridAddCommand [svgIcon]="icons.plusCircle">
          Create
        </button>
      }
      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.xCircle" [disabled]="svc.selectedKeys.length == 0" (click)="svc.newDelete($event)">Remove</button>
      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save" [disabled]="!svc.hasChanges()" (click)="svc.saveChanges();">Save</button>
      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel" [disabled]="!svc.hasChanges()" (click)="svc.cancelChanges();">Cancel</button>

      <pxd-grid-menu [columns]="columns()" [grid]="grid" [columnSettingsKey]="columnSettingsKey()"></pxd-grid-menu>
    </div>
  </ng-template>

  @if (config()?.selectRow && config().selectRow === true) {
    <kendo-grid-checkbox-column [locked]="lockSelectionCheckbox()" [reorderable]="false" [width]="40" [showSelectAll]="false"></kendo-grid-checkbox-column>
  }

  @for (col of columns(); track col) {
    <!--// Numeric //-->
    @if (col.params.type === 'numeric') {
      @if (col.params?.display === true) {
        <kendo-grid-column
          [field]="col.field"
          [editable]="col.params?.editable === false ? false : true"
          [hidden]="col.params?.hide ? col.params.hide : false"
          [locked]="col.params?.lock ? col.params.lock : false"
          [width]="col.params?.width ? col.params.width : 120"
          [editor]="'numeric'"
          [filter]="col.params?.filter ? col.params.filter : null">
          <ng-template kendoGridEditTemplate let-dataItem let-rowIndex="rowIndex" let-formGroup="formGroup">
            <kendo-numerictextbox
              [formControl]="formGroup.get(col.field)"
              [autoCorrect]="true"
              [spinners]="true"
              [format]="col.params?.format"
              [decimals]="col.params?.decimals != null ? col.params.decimals : null"
              (input)="col.params?.valueChange ? svc.valueChange($event, col.params.valueChange, dataItem) : null">
            </kendo-numerictextbox>
          </ng-template>
          <ng-template kendoGridHeaderTemplate let-dataItem let-rowIndex>
            {{col.title}}
          </ng-template>
          <ng-template
            kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-numeric-filter-cell
              [column]="column"
              [filter]="filter"
              [format]="col.params?.format"
              [showOperators]="col.params?.showOperators ?? true"
              [spinners]="false">
            </kendo-grid-numeric-filter-cell>
          </ng-template>
        </kendo-grid-column>
      }
    }
    <!--// Drop Down List //-->
    @if (col.params.type === 'dropdownlist') {
      @if (col.params?.display === true) {
        <kendo-grid-column
          [field]="col.field"
          [editable]="col.params?.editable === false ? false : true"
          [hidden]="col.params?.hide ? col.params.hide : false"
          [locked]="col.params?.lock ? col.params.lock : false"
          [width]="col.params?.width ? col.params.width : 120">
          <ng-template kendoGridHeaderTemplate let-dataItem let-rowIndex>
            {{col.title}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            @if (col.params?.viewData) {
              {{ svc[col.params.viewData.func][ dataItem[col.params.viewData.key] ] }}
            }
            @if (!col.params?.viewData) {
              {{dataItem[col.field]}}
            }
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex">
            <kendo-dropdownlist
              [defaultItem]="col.params.defaultItem"
              [data]="svc[col.params.data]"
              textField="{{col.params.textField}}"
              valueField="{{col.params.valueField}}"
              [valuePrimitive]="true"
              (valueChange)="col.params?.valueChange ? svc.valueChange($event, col.params.valueChange, dataItem) : null"
              [formControl]="formGroup.get(col.params.formControl)">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>
      }
    }
    <!--// Checkbox //-->
    @if (col.params.type === 'checkbox') {
      @if (col.params?.display === true) {
        <kendo-grid-column
          [title]="col.title"
          [field]="col.field"
          [editable]="col.params?.editable === false ? false : true"
          [hidden]="col.params?.hide ? col.params.hide : false"
          [locked]="col.params?.lock ? col.params.lock : false"
          [width]="col.params?.width ? col.params.width : 120"
          filter="boolean">
          <ng-template kendoGridHeaderTemplate let-dataItem let-rowIndex>
            {{col.title}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" [checked]="dataItem[col.field]" disabled />
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
            <input type="checkbox" [formControl]="formGroup.get(col.field)" />
          </ng-template>
        </kendo-grid-column>
      }
    }
    <!--// General //-->
    @if (col.params.type !== 'dropdownlist' && col.params.type !== 'numeric' && col.params.type !== 'checkbox') {
      @if (col.params?.display === true) {
        <kendo-grid-column
          [title]="col.title"
          [field]="col.field"
          [editable]="col.params?.editable === false ? false : true"
          [hidden]="col.params?.hide ? col.params.hide : false"
          [locked]="col.params?.lock ? col.params.lock : false"
          [width]="col.params?.width ? col.params.width : 120">
          <ng-template kendoGridHeaderTemplate let-dataItem let-rowIndex>
            {{col.title}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem[col.field]}}
          </ng-template>
        </kendo-grid-column>
      }
    }
  }

  <kendo-grid-excel fileName="Export.xlsx" [fetchData]="svc.allData">
    @for (c of columns(); track c) {
      <kendo-excelexport-column [field]="c.field" [title]="c.title" [hidden]="!c.params?.display"></kendo-excelexport-column>
    }
  </kendo-grid-excel>

  @if (config()?.customPaging) {
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="10"></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-info></kendo-pager-info>
      <select type="number" id="custom-page-size-options" [(ngModel)]="svc.gridState.take" (change)="pageSizeChange($event)" class="form-control page-size-dropdown">
        @for (pageSize of this.config().customPaging; track pageSize) {
          <option [value]="pageSize">{{pageSize}}</option>
        }
      </select>
    </ng-template>
  }
</kendo-grid>